import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import LegacyPathCard, { LegacyPathCardProps } from '../LegacyPathCard'
import type { JourneyNotice } from '../types'

interface LegacyFidelityProps {
  hidden: boolean
  loyaltyBannerText: string
  loyaltyBannerHidden: boolean
  pdlWarningText: string
  pdlWarningHidden: boolean
  pdlOkBannerText: string
  pdlOkBannerHidden: boolean
  card: LegacyPathCardProps
  contactWarning: JourneyNotice
}

const LegacyFidelity = ({
  hidden,
  loyaltyBannerText,
  loyaltyBannerHidden,
  pdlWarningText,
  pdlWarningHidden,
  pdlOkBannerText,
  pdlOkBannerHidden,
  card,
  contactWarning,
}: LegacyFidelityProps) => {
  if (hidden) {
    return null
  }

  return (
    <>
      <SDNotification hidden={loyaltyBannerHidden} type='positive' primaryText={loyaltyBannerText} />
      <SDNotification hidden={pdlWarningHidden} type='warning' primaryText={pdlWarningText} />
      <SDNotification hidden={pdlOkBannerHidden} type='positive' primaryText={pdlOkBannerText} />
      <LegacyPathCard {...card} />
      <SDNotification hidden={contactWarning.hidden} type='warning' primaryText={contactWarning.text} />
    </>
  )
}

export default LegacyFidelity
